import script from "./LoanProgramDetailsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoanProgramDetailsCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__